import { handleActions } from 'redux-actions';

import { RESPONSIVE_SET_DEVICE } from './actions';

export const initialState = { phone: false, tablet: false, mobile: false };

export default handleActions(
  {
    [RESPONSIVE_SET_DEVICE]: (state, { payload }) => ({
      phone: !!payload.phone,
      tablet: !!payload.tablet,
      mobile: !!payload.mobile,
    }),
  },
  initialState
);
